import { api } from '../rest';

const listSensors = async () => {
  const { data } = await api.get('/sensor');
  return data.elements;
};

export default { listSensors };
